export const MAX_32_BIT_INT = 2147483647;
export const DEFAULT_PAGE_SIZE = 100;